import { getLocale } from '@websky/core/src/utils';
import i18next from 'i18next';
import { CardType } from '@websky/core/src/PromoLoader/types';
var currentLocale = getLocale();
var isProd = process.env.NODE_ENV === 'production';
export var companyInfo = {
    facebook: '',
    instagram: '',
    vk: '',
    baggage: "https://yamalaero.ru/passengers/baggage/",
    meal: 'https://yamalaero.ru/passengers/services/meals/',
    seat: 'https://yamalaero.ru/passengers/services/seats/',
    legal: "https://yamalaero.ru/passengers/rules/on-board/",
    privacyPolicy: "https://yamalaero.ru/privacy/",
    exarePrivacyPolicyURL: 'https://yamalaero.ru/privacy/',
    exareRulesURL: 'https://yamalaero.ru/passengers/booking/returns/',
    insurance: "https://yamalaero.ru/passengers/services/insurance/",
    loyaltyProgramRegistrationUrl: "",
    loyaltyProgramName: '',
    iataCode: 'YC',
    loyalty: {
        links: [
            {
                title: 'Status',
                url: ""
            },
            {
                title: 'Earn miles',
                url: ""
            },
            {
                title: 'Use miles',
                url: ""
            },
            {
                title: 'FAQ',
                url: ""
            }
        ]
    },
    multiInsurance: true,
    specialDocumentForInsurance: true
};
export var i18n = {
    ru: {
        Title: {
            companyName: 'Yamal'
        },
        LoginPage: {
            'Email / Phone / Card number': 'Эл. почта',
            'Please enter a valid Email / Phone / Card number': 'Пожалуйста введите Эл. почту'
        },
        PromoLoader: {
            Autumn_title: 'Волшебная осень!',
            Autumn_text: 'Специальные предложения авиакомпании «Ямал»',
            Winter_title: 'Волшебная зима!',
            Winter_text: 'Специальное предложение на зимние рейсы',
            Summer_title: 'Яркое лето!',
            Summer_text: 'Специальное предложение на летние рейсы',
            Subsidized_title: 'Субсидированые авиабилеты',
            Subsidized_text: 'Проверьте возможность сэкономить на этапе ввода пассажирских данных',
            Buy_online_title: 'Покупайте на сайте',
            Buy_online_text: 'Экономьте покупая на сайте дополнительный багаж,\n место в салоне и другие услуги. ',
            Spring_title: 'Долгожданная весна!',
            Spring_text: 'Специальное предложение на весенние рейсы'
        },
        Account: {
            'My cabinet': 'Кабинет',
            'Travel companions': 'Пассажиры',
            Save: 'Добавить',
            'Buy a ticket': 'Купить билет',
            'My orders': 'Мои заказы',
            'My appeals': 'Мои обращения'
        },
        Warnings: {
            'An error occurred when booking a subsidy': 'Мы не смогли применить субсидии для пассажиров данной брони. Если вы считаете, что допущена ошибка, свяжитесь с нами по телефону 8 (800) 234-44-02',
            'An error occurred during the issue of tickets with subsidies, the money will be return.': 'Мы не смогли выписать билеты с применением субсидии для пассажиров данной брони. Средства будут возвращены вам согласно способу, которым оплачивался заказ. Если вы считаете, что допущена ошибка, свяжитесь с нами по телефону 8 (800) 234-44-02'
        },
        translation: {
            'Please select another date or modify your search. If you wish to purchase a ticket for this particular date, please contact customer support.': "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0440\u0443\u0433\u0443\u044E \u0434\u0430\u0442\u0443 \u0438\u043B\u0438 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043F\u043E\u0438\u0441\u043A. <a href='https://yamalaero.ru/booking/#/schedule/' target='_blank'>\u041E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043C \u0440\u0435\u0439\u0441\u043E\u0432</a>",
            'We couldn\'t find any flights for given dates': 'К сожалению, мы не нашли свободных мест, либо на заданную дату рейсы не выполняются'
        },
        Exchange: {
            'Please select another date or modify your search. If you wish to purchase a ticket for this particular date, please contact customer support.': 'Пожалуйста, выберите другую дату или измените свой поиск.'
        },
        Refund: {
            NeedConfirm: 'Подтвердите возврат',
            ManualOperationError: 'Не удалось автоматически рассчитать стоимость возврата. Ваша заявка будет обработана вручную. Продолжить?'
        },
        Subsidy: {
            'Check me in subsidy list': 'Являюсь членом многодетной семьи ЯНАО. Согласен на проверку права на льготную перевозку'
        },
        Checkout: {
            '{{items}} items with a total weight of {{capacity}}': 'до {{items}}x мест общим весом до {{capacity}}',
            'places up {{weight}}': 'места до {{weight}}',
            kg: 'кг'
        },
        IncludedBaggage: {
            Equipment: 'Нестандартный багаж и животное в салоне',
            BaggageCard_Equipment: 'Вам нужно взять <a href="https://yamalaero.ru/passengers/baggage/special/" target="_blank">нестандартный багаж</a> или <a href="https://yamalaero.ru/passengers/services/pets/" target="_blank">животное в салон?</a>'
        },
        SeatMap: {
            SeatMap_Preferred: 'Повышенной комфортности',
            SeatMap_Comfort: 'Выбор места',
            SeatMap_Standart: 'Выбор места'
        },
        PaymentForm: {
            'Edit order': 'Изменить услуги в заказе'
        },
        MealPage: {
            'Pay attention! You can familiarize yourself with the ration of free in-flight meals included in the tariff on the website in the tab Meal': 'Обращаем внимание! С рационом бесплатного бортового питания, включенного в тариф, можно ознакомиться на сайте во вкладке <a href="https://yamalaero.ru/passengers/services/meals" target="_blank">«Питание»</a>.\nВ случае, если предоставленное на рейсе бортовое питание не будет содержать вложенный информационный листок-вкладыш с маркировкой пищевой продукции, по Вашему запросу бортпроводник ознакомит с ингредиентами, входящими в состав предоставляемого рациона питания.'
        },
        Consents: {
            agreement_rules: 'Я ознакомился(-лась) с {{links}}, оплатой данных доп. услуг, принимаю их и согласен с ними.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">правилами страхования</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'условиями публичной оферты «{{name}}»'
        },
        Aeroexpress: {
            roundtrip: 'В оба конца',
            business_roundtrip: 'В оба конца (Бизнес)'
        },
        Contacts: {
            'If special arrangements are required for the disabled passenger, please fill request form or call the hotline at 8 800 234 4402.': 'Если требуются особые условия перевозки пассажира с ограниченными возможностями заполните <a href="https://yamalaero.ru/passengers/categories/special/" target="_blank">форму запроса</a> специального сопровождения или обратитесь по телефону горячей линии <a href="tel:88002344402" type="tel">8 800 234 4402</a>.'
        }
    },
    en: {
        Title: {
            companyName: 'Yamal'
        },
        LoginPage: {
            'Email / Phone / Card number': 'Email',
            'Please enter a valid Email / Phone / Card number': 'Please enter a valid Email'
        },
        PromoLoader: {
            Summer_title: 'Welcome summer!',
            Summer_text: 'Special offer for summer flights',
            Autumn_title: 'Meet autumn!',
            Autumn_text: 'Special offer for autumn flights',
            Winter_title: 'Magical winter!',
            Winter_text: 'Special offer for winter flights',
            Subsidized_title: 'Subsidized flights',
            Subsidized_text: 'Check the opportunity to save money at the stage of entering passenger data',
            Buy_online_title: 'Buy on the website',
            Buy_online_text: 'Save money by buying additional luggage, a seat\nin the cabin and other services on the website.',
            Spring_title: 'Welcome spring!',
            Spring_text: 'Special offer for spring flights'
        },
        Checkin: {
            'Choose passengers for check-in': 'Online check-in',
            'Ticket number or booking reference': 'Order ID, booking ID or eTicket number',
            'Passenger last name': 'Surname'
        },
        RetrieveBooking: {
            Open: 'Find'
        },
        Account: {
            Orders: 'My bookings',
            'My cabinet': 'Cabinet',
            'Travel companions': 'Passengers',
            Save: 'Add',
            'Buy a ticket': 'Buy a ticket',
            'My orders': 'My orders',
            'My appeals': 'My appeals'
        },
        Exchange: {
            Next: 'Continue'
        },
        Refund: {
            Request_Continue: 'Send request',
            ManualOperationError: 'Failed to automatically calculate the refund amount. Your request will be processed manually. Continue?'
        },
        Warnings: {
            'An error occurred when booking a subsidy': 'Cannot to book this order with subsidy. Please contact with us by phone 8 (800) 234-44-02'
        },
        Checkout: {
            '{{items}} items with a total weight of {{capacity}}': '{{items}} items with a total weight of {{capacity}}',
            'places up {{weight}}': 'places up {{weight}}'
        },
        MealPage: {
            'Pay attention! You can familiarize yourself with the ration of free in-flight meals included in the tariff on the website in the tab Meal': 'Pay attention! You can familiarize yourself with the ration of free in-flight meals included in the tariff on the website in the tab <a href="https://yamalaero.ru/passengers/services/meals" target="_blank">«Meal»</a>.\nIn the event that the in-flight meals provided on the flight do not contain an enclosed information leaflet with labeling of food products, at your request, the flight attendant will familiarize you with the ingredients that make up the provided meal ration.'
        },
        Consents: {
            agreement_rules: 'I have read {{links}}, payment for these additional services, and I accept and agree to them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">insurance regulations</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        translation: {
            'We couldn\'t find any flights for given dates': 'Unfortunately, we did not find any available seats, or flights are not operated on the specified date'
        },
        Aeroexpress: {
            business_roundtrip: 'Business round trip'
        },
        Contacts: {
            'If special arrangements are required for the disabled passenger, please  fill request form or call the hotline at 8 800 234 4402.': "If special arrangements are required for the disabled passenger, please fill <a href=\"https://yamalaero.ru/passengers/categories/special/\" target=\"_blank\">request form</a> or call the hotline at <a href=\"tel:88002344402\" type=\"tel\">8 800 234 4402</a>."
        }
    },
    kk: {
        Consents: {
            agreement_rules: 'I have read {{links}}, payment for these additional services, and I accept and agree to them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">insurance regulations</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        translation: {
            'We couldn\'t find any flights for given dates': 'Unfortunately, we did not find any available seats, or flights are not operated on the specified date'
        },
        Refund: {
            ManualOperationError: 'Failed to automatically calculate the refund amount. Your request will be processed manually. Continue?'
        }
    },
    fr: {
        Consents: {
            agreement_rules: 'I have read {{links}}, payment for these additional services, and I accept and agree to them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">insurance regulations</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        translation: {
            'We couldn\'t find any flights for given dates': 'Unfortunately, we did not find any available seats, or flights are not operated on the specified date'
        },
        Refund: {
            ManualOperationError: 'Failed to automatically calculate the refund amount. Your request will be processed manually. Continue?'
        }
    },
    de: {
        Consents: {
            agreement_rules: 'I have read {{links}}, payment for these additional services, and I accept and agree to them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">insurance regulations</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        translation: {
            'We couldn\'t find any flights for given dates': 'Unfortunately, we did not find any available seats, or flights are not operated on the specified date'
        },
        Refund: {
            ManualOperationError: 'Failed to automatically calculate the refund amount. Your request will be processed manually. Continue?'
        }
    },
    zh: {
        Consents: {
            agreement_rules: 'I have read {{links}}, payment for these additional services, and I accept and agree to them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">insurance regulations</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        translation: {
            'We couldn\'t find any flights for given dates': 'Unfortunately, we did not find any available seats, or flights are not operated on the specified date'
        },
        Refund: {
            ManualOperationError: 'Failed to automatically calculate the refund amount. Your request will be processed manually. Continue?'
        }
    }
};
export var promoLoaders = [
    // {
    // 	type: CardType.City,
    // 	title: 'Winter_title',
    // 	text: '',
    // 	image: 'https://cdn.websky.aero/content/YC/images/promoLoader8.jpeg'
    // },
    // {
    // 	type: CardType.City,
    // 	title: 'Subsidized_title',
    // 	text: 'Subsidized_text',
    // 	image: 'https://cdn.websky.aero/content/YC/images/promoLoader3.jpg'
    // },
    {
        type: CardType.City,
        title: 'Buy_online_title',
        text: 'Buy_online_text',
        image: 'https://cdn.websky.aero/content/YC/images/promoLoader2.jpg'
    }
    // {
    // 	type: CardType.City,
    // 	title: 'Summer_title',
    // 	text: 'Summer_text',
    // 	image: 'https://cdn.websky.aero/content/YC/images/promoLoader9.jpg'
    // }
    // {
    // 	type: CardType.City,
    // 	title: 'Winter_title',
    // 	text: 'Winter_text',
    // 	image: 'https://cdn.websky.aero/content/YC/images/promoLoader10.jpg'
    // }
    // {
    // 	type: CardType.City,
    // 	title: 'Spring_title',
    // 	text: 'Spring_text',
    // 	image: 'https://cdn.websky.aero/content/YC/images/promoLoader9.jpg'
    // }
];
export var defaultSteps = {
    flights: {
        label: i18next.t('Stepbar:Flights')
    },
    baggage: {
        label: i18next.t('Stepbar:Baggage')
    },
    passengers: {
        label: i18next.t('Stepbar:Passengers')
    },
    payment: {
        label: i18next.t('Stepbar:Payment')
    }
};
export var yamalPassengersConfig = [
    {
        code: 'ADT',
        isAdult: true,
        defaultCount: 1
    },
    {
        code: 'CLD',
        isAdult: false,
        maxCountWithoutAdult: 1
    },
    {
        code: 'INF',
        isAdult: false
    },
    {
        code: 'INS',
        isAdult: false
    }
];
export var config = {
    global: {
        companyInfo: companyInfo,
        maxBaggagePerPassenger: 4,
        i18n: i18n,
        insurance: {
            upsaleStrategy: ['checkout-before-payment'],
            insurancePriorities: ['ON_BG_ZV_NS_V_DOC_349'],
            allowImplicitConfirm: true
        },
        showIsActualizationResultOk: false,
        currentUserInGlobalScope: true,
        findOrderURL: 'https://yamalaero.ru/booking/#/find',
        socialAuthAvailability: {
            facebook: false,
            google: false,
            vk: false,
            tinkoff: true
        },
        seatMap: {
            splitByCabin: false
        },
        subscriptionCheckboxDefaultState: true
    },
    Account: {
        engineURL: 'https://yamalaero.ru/booking/',
        showUserPhoneInput: false,
        showSubscribeCheckbox: true
    },
    Engine: {
        defaultSteps: defaultSteps,
        calendarDaysCount: 5,
        searchFormURL: isProd ? './' : null,
        checkInURL: 'https://yamalaero.ru/check-in/',
        promoLoaders: promoLoaders,
        showRefundRedirectButton: true,
        checkInEnabled: true,
        mealDefaultFilterButtonPlacement: 'end'
    },
    SearchForm: {
        showPriceGraph: false,
        enableComplexRoute: true,
        showPricesInDatepicker: false,
        requestCoordintates: {
            desktop: false
        },
        passengersConfig: yamalPassengersConfig,
        offerHotels: true,
        offerHotelsLink: 'https://hotels.yamal.aero/hotels/',
        offerHotelsUtm: 'hotels_in_nemo'
    }
};
